
import { Component, Prop, Vue } from 'vue-property-decorator';
import {BoxRequest} from "@/models/BoxRequest";
import {Order} from "@/models/Order";
import {AxiosError} from "axios";
import ErrorHandler from "@/support/ErrorHandler";

@Component<BlockOrders>({})
export default class BlockOrders extends Vue {
  @Prop()
  private request!: BoxRequest;

  protected get orders()
  {
    if (!this.request || !this.request.orders) {
      return [];
    }

    return this.request.orders;
  }

  protected get isBlacklisted() {
    // @ts-ignore
    if (! this.request || ! this.request.user || ! this.request.user.profile)  {
      return false;
    }

    // @ts-ignore
    return this.request.user.profile.status === 'blacklist';
  }

  protected get hasTooManyActiveOrders() {
    // @ts-ignore
    if (!this.request || ! this.request.user || ! this.request.user.rights)  {
      return false;
    }

    // @ts-ignore
    return this.request.user.rights.has_too_many_active_orders;
  }

  protected get hasOpenInvoice() {
    // @ts-ignore
    if (!this.request || ! this.request.user || ! this.request.user.profile)  {
      return false;
    }

    // @ts-ignore
    return this.request.user.profile.status === 'open_invoice';
  }

  protected createOrder() {
    if (! this.request || ! this.request.user) {
      return;
    }

    if (this.isBlacklisted || this.hasOpenInvoice || this.hasTooManyActiveOrders) {
      return;
    }

    const orderPayload = {
      user: this.request.user.id,
      box_request: this.request.id,
      box_type: this.request.type || 'styled_box',
    };
    new Order()
      .create(orderPayload)
      .then((response: any) => {
        this.$router.push({
          name: "webshop.order",
          params: { id: response.id }
        });
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }
}
